import Collapse from "@material-ui/core/Collapse";
import {
  default as List,
  default as ListItemButton,
} from "@material-ui/core/List";
import ListItemText from "@material-ui/core/ListItemText";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import { toastr } from "react-redux-toastr";
import * as React from "react";
import { useHistory } from "react-router-dom";
import "./LeftDrawerCss.scss";
import { toggleDrawer } from "./drawerSlice";
import { useDispatch } from "react-redux";
const NavDrawer = ({
  tabAccess,
  title,
  links,
  item,
  setSelected,
  ...props
}) => {
  const [open, setOpen] = React.useState(false);
  const [showSubList, setShowSubList] = React.useState(false);

  const history = useHistory();

  const handleClick = () => {
    setOpen(!open);
  };
  const dispatch = useDispatch();
  return (
    <div className="nav-drawer">
      <List>
        <ListItemButton onClick={handleClick} className="d-flex">
          <ListItemText
            primary={title}
            onClick={() => {
              history.push(item.url);
              setSelected(item.id);
              dispatch(toggleDrawer({ type: "left" }));
            }}
          />

          {showSubList === false && item?.subList?.length > 0 && (
            <ChevronRightIcon
              onClick={() => {
                setShowSubList(!showSubList);
              }}
            />
          )}

          {showSubList && (
            <KeyboardArrowDown
              onClick={() => {
                setShowSubList(!showSubList);
              }}
            />
          )}
          
          {/* {open && title === "Finances" ? <ExpandLess /> : <ChevronRightIcon />} */}
        </ListItemButton>

        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton>
              {item?.subList?.map((link, index) => {
                if (title === "Finances")
                  return (
                    <ListItemText
                      key={index}
                      primary={
                        <div className="links">
                          <span className="icon">
                            <i className="far fa-window-minimize"></i>
                          </span>
                          <span className="links-list">{link.label}</span>
                        </div>
                      }
                      onClick={() => {
                        dispatch(toggleDrawer({ type: "left" }));
                        setSelected(item.id);
                        history.push(link.path);
                      }}
                    />
                  );
              })}
            </ListItemButton>
          </List>
        </Collapse>
      </List>
    </div>
  );
};

export default NavDrawer;
